"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralSettings = exports.loadMenu = void 0;
const material_1 = require("@mui/material");
const ColorChangingButton_1 = __importDefault(require("../ColorChangingButton"));
const react_1 = __importDefault(require("react"));
const actions_1 = require("../../actions/actions");
const RespawnMenu_1 = require("../RespawnMenu");
const create_1 = require("../../create");
const sdkIntegration_1 = require("../../sdkIntegration");
let buttonConfig = {
    idle: {
        fillColor: '#7C4E4D',
        outerBorderColor: '#362D44',
        innerBorderColor: '#543131',
    },
    hover: {
        fillColor: '#CC7A82',
        outerBorderColor: '#362D44',
        innerBorderColor: '#AA5561',
    },
    down: {
        fillColor: '#CC7A82',
        outerBorderColor: '#362D44',
        innerBorderColor: '#AA5561',
    }
};
function loadMenu(currentGame, token, guestAccount) {
    sdkIntegration_1.cmds.gameplayStop();
    (0, actions_1.toggleIngameSettingsMenu)(false);
    (0, actions_1.gameLoadComplete)(false);
    (0, actions_1.updateLoadProgress)(0);
    let val = 0;
    let interval = setInterval(() => {
        val += 1;
        (0, actions_1.updateLoadProgress)(val);
        if (val === 100) {
            clearInterval(interval);
        }
    }, 2);
    setTimeout(() => {
        (0, RespawnMenu_1.handleMainMenu)(token, guestAccount);
        if (currentGame === 'mainportal') {
            (0, actions_1.setGame)(undefined);
        }
        setTimeout(() => {
            (0, create_1.resetPortalCameraPosition)(currentGame);
            (0, create_1.resetGameObjects)('mainportal', true);
            setTimeout(() => {
                // resetPortalCameraPosition(currentGame)
                (0, actions_1.gameLoadComplete)(true);
                clearInterval(interval);
            }, 100);
        }, 100);
    }, 100);
}
exports.loadMenu = loadMenu;
function GeneralSettings({ currentGame, singleGame, token, guestAccount, handleClose }) {
    return react_1.default.createElement(material_1.Grid, { container: true, xs: 12, alignItems: "center", justifyContent: "center" },
        react_1.default.createElement(material_1.Grid, { container: true, item: true, xs: 12, alignItems: "center", justifyContent: "center" },
            react_1.default.createElement(ColorChangingButton_1.default, { config: buttonConfig, title: 'Game Menu', buttonFunction: () => {
                    loadMenu(currentGame, token, guestAccount);
                } })),
        //  !singleGame &&
        react_1.default.createElement(material_1.Grid, { container: true, item: true, alignItems: "center", justifyContent: "center", xs: 12 },
            react_1.default.createElement(ColorChangingButton_1.default, { config: buttonConfig, title: 'Game Selection', buttonFunction: () => {
                    loadMenu('mainportal', token, guestAccount);
                } })));
}
exports.GeneralSettings = GeneralSettings;
